// Normalize the given value on a scale of 0 to 100.
export function normalize(value: number, min: number, max: number): number {
  return ((value - min) * 100) / (max - min);
}
